import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import pure from 'recompose/pure'

const withImage = ({ src, onLoad, onError }) => {
    let unmounted = false,
        image

    const handleImageLoad = () => {
        image = new Image()

        image.onload = e => {
            if (!unmounted) {
                onLoad && onLoad(e, image)
                setImageLoaded(true)
            }
        }

        image.onerror = e => {
            onError && onError(e)
        }

        image.src = src
    }

    const [imageLoaded, setImageLoaded] = useState(false)

    // Handle mounting and unmounting
    useEffect(() => {
        handleImageLoad()

        return () => {
            unmounted = true
            image = null
        }
    }, [])

    // Load image when src changes
    useEffect(() => {
        image = null
        setImageLoaded(false)
        handleImageLoad()
    }, [src])

    return [imageLoaded, image]
}

const BackgroundImageOnLoad = props => {
    const [imageLoaded, image] = withImage(props)

    return typeof props.children == 'function' ? props.children({ imageLoaded, image }) : props.children
}

BackgroundImageOnLoad.defaultProps = {
    children: null,
}

BackgroundImageOnLoad.propTypes = {
    src: PropTypes.string.isRequired,
    onLoad: PropTypes.func,
    onError: PropTypes.func,
}

export default compose(pure)(BackgroundImageOnLoad)
